import { createContext } from "react";

import useScanFormOptions from "shared/Scan/useScanFormOptions";

import { NewScanScheduleStep } from "./types";

type NewScanScheduleContextProps = {
  currentStep: NewScanScheduleStep;
  currentStepIndex: number;
  goToStep: (step: NewScanScheduleStep) => void;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  formOptions: ReturnType<typeof useScanFormOptions>;
};

export const NewScanScheduleContext = createContext<NewScanScheduleContextProps | undefined>(
  undefined
);
NewScanScheduleContext.displayName = "NewScanScheduleContext";
